export default __webpack_public_path__ + "static/media/ac_daa.305d59d9.bmp";